import react from 'react';
import styled from 'styled-components';

export default function Loader({ color, height, width }: any) {
  return (
    <img src={'/images/loader-' + color + '.svg'} width={width} height={height} />
  )
}